import { Component, Input } from "@angular/core";
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from "@angular/forms";
import { v4 as uuidv4 } from "uuid";

@Component({
    selector: "love-it-enum-radio-selector",
    templateUrl: "./enum-radio-selector.component.html",
    styleUrl: "./enum-radio-selector.component.scss",
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: EnumRadioSelectorComponent,
            multi: true,
        },
    ],
    standalone: false
})
export class EnumRadioSelectorComponent implements ControlValueAccessor {
  @Input() enumValues: Array<any>;
  @Input() bindLabel = "value";
  @Input() bindValue = "value";

  formControl = new FormControl();
  unique = uuidv4();

  writeValue(obj: any): void {
    this.formControl.setValue(obj, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.formControl.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any) {}

  setDisabledState(isDisabled: boolean) {
    if (isDisabled) {
      this.formControl.disable({ emitEvent: false });
    } else {
      this.formControl.enable({ emitEvent: false });
    }
  }
}
